<template>
    <v-container class="container" fluid>
        <v-card class="mb-5">
            <v-toolbar dense dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >New Fuel Expenses Entries</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon left to="/administration/fuel"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-form ref="formAdd" v-model="valid" lazy-validation>
                <v-row
                    justify="center"
                    style="margin-top: 0px;padding-top: 0px;"
                    class="mb-1"
                >
                    <v-col sm="12" md="3" lg="2">
                        <v-combobox
                            v-model="supplier"
                            placeholder="Select supplier"
                            class="mx-3"
                            label="Supplier"
                            :items="suppliers"
                            :rules="[v => !!v || 'Required']"
                            required
                            dense
                            hide-details
                            :item-text="'Supplier'"
                            :item-value="'OOSupplierId'"
                            auto-select-first
                        ></v-combobox>
                    </v-col>
                    <v-col sm="12" md="3" lg="1">
                        <v-text-field
                            label="Stmt Number"
                            class="mx-3"
                            dense
                            hide-details
                            v-model="stNumber"
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="3" lg="1">
                        <v-text-field
                            label="Stmt Date"
                            class="mx-3"
                            hide-details
                            dense
                            v-model="stDate"
                            v-mask="'####-##-##'"
                            :rules="dateRules"
                        ></v-text-field>
                    </v-col>

                    <v-col sm="12" md="3" lg="2">
                        <input
                            type="file"
                            class="mt-2 float-left"
                            v-if="!chagn"
                            @change="readExcel"
                        />
                        <v-text-field
                            v-model="searchStatement"
                            v-on:keyup.enter="loadShifts(1)"
                            dense
                            hide-details
                            v-if="chagn"
                            label="Search"
                        ></v-text-field>
                    </v-col>
                    <v-btn
                        color="primary"
                        class="mt-4 ml-12"
                        icon
                        v-if="!chagn"
                        @click="sendExcel"
                        ><v-icon>mdi-upload</v-icon></v-btn
                    >
                    <v-btn
                        color="primary"
                        class="mt-4 ml-12"
                        v-if="chagn"
                        icon
                        @click="loadShifts"
                        ><v-icon>mdi-magnify</v-icon></v-btn
                    >
                    <v-btn
                        color="primary"
                        class="mt-4"
                        icon
                        @click="chagn = !chagn"
                    >
                        <v-icon>mdi-swap-horizontal</v-icon></v-btn
                    >
                    <v-col cols="2">
                        <v-combobox
                            v-model="driver"
                            class="mx-3"
                            label="Drivers"
                            :items="drivers"
                            dense
                            hide-details
                            :item-text="'Driver'"
                            :item-value="'Driver'"
                            v-if="action"
                            auto-select-first
                        ></v-combobox>
                        <v-text-field
                            v-else
                            label="Search"
                            v-model="search"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-btn color="primary" @click="save" small class="mt-5">
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn
                        color="primary"
                        small
                        class="mt-5 ml-5"
                        @click="$store.state.payroll.entries = true"
                    >
                        Manual
                    </v-btn>

                    <v-btn
                        icon
                        color="primary"
                        @click="loadShifts(0)"
                        small
                        class="mt-5 ml-5"
                    >
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </v-row>
            </v-form>
            <v-container grid-list-xs fluid>
                <v-bottom-navigation
                    v-model="action"
                    height="47"
                    color="teal"
                    grow
                    style="display:block;"
                >
                    <v-btn @click="action = 0">
                        <span>Upload File</span>

                        <v-icon>mdi-content-save-move</v-icon>
                    </v-btn>
                    <v-btn @click="chargeExcel()">
                        <span>Add</span>

                        <v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>

                    <v-btn @click="getEntriesbyStNumber()">
                        <span>Edit</span>

                        <v-icon>mdi-file-edit</v-icon>
                    </v-btn>

                    <v-btn
                        @click="uploadFile()"
                        v-show="action == 0 || action == 3"
                        class="float-right"
                    >
                        <span>Save</span>

                        <v-icon color="primary">mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn
                        @click="downLoadExcelRecored"
                        v-show="action == 2 || action == 4"
                        class="float-right"
                    >
                        <span>Download</span>

                        <v-icon color="success">mdi-microsoft-excel</v-icon>
                    </v-btn>
                </v-bottom-navigation>
                <!-- show excel File table -->
                <v-data-table
                    :headers="headers"
                    :items="excel"
                    :items-per-page="40"
                    fixed-header
                    height="650px"
                    dense
                    v-if="action == 0 || action == 3"
                    class="elevation-1"
                ></v-data-table>
                <!-- new entry table  -->
                <v-data-table
                    :headers="titles"
                    :items="filterSearchItems"
                    :items-per-page="40"
                    dense
                    fixed-header
                    height="650px"
                    v-if="action == 1"
                    class="elevation-1"
                >
                    <template v-slot:top>
                        <v-container grid-list-xs fluid>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Search"
                                        v-model="searchRows"
                                        hide-details
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:item.shifts="{ item }">
                        <v-combobox
                            placeholder="Select shift"
                            class="mx-3"
                            dense
                            hide-details
                            v-model="item.shifts"
                            :items="shifts"
                            required
                            :rules="[v => !!v || 'Required']"
                            :item-text="'text'"
                            :item-value="'ShiftDetail'"
                            auto-select-first
                            :disabled="item.Save"
                        >
                        </v-combobox>
                    </template>
                    <template v-slot:item.Date="{ item }">
                        <v-text-field
                            v-model="item.Date"
                            hide-details
                            dense
                            :placeholder="$store.state.placeholder"
                            v-mask="'####-##-##'"
                            :rules="dateRules"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.invoiceNo="{ item }">
                        <v-text-field
                            v-model="item.invoiceNo"
                            hide-details
                            dense
                            :rules="[v => !!v || 'Required']"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.Qty="{ item }">
                        <v-text-field
                            v-model="item.Qty"
                            hide-details
                            dense
                            @change="calculate(item)"
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.GST="{ item }">
                        <v-text-field
                            v-model="item.GST"
                            hide-details
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.total="{ item }">
                        <v-text-field
                            v-model="item.total"
                            hide-details
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.actualPrice="{ item }">
                        <v-text-field
                            v-model="item.actualPrice"
                            hide-details
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.actualCost="{ item }">
                        <v-text-field
                            v-model="item.actualCost"
                            hide-details
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.expenseType="{ item }">
                        <v-combobox
                            class="mx-3"
                            v-model="item.expenseType"
                            :items="fuelType"
                            dense
                            hide-details
                            :item-text="'Type'"
                            :item-value="'OOExpTypeId'"
                            :rules="[v => !!v || 'Required']"
                            auto-select-first
                        ></v-combobox>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-checkbox
                            v-model="item.status"
                            :value="item.status"
                            hide-details
                            :disabled="item.Save"
                            dense
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.Province="{ item }">
                        <v-combobox
                            placeholder="Select province"
                            class="mx-3"
                            v-model="item.Province"
                            :items="provinces"
                            required
                            hide-details
                            dense
                            :rules="[v => !!v || 'Required']"
                            :item-text="'Province'"
                            :item-value="'ProvinceAbbr'"
                            auto-select-first
                        >
                        </v-combobox>
                    </template>
                </v-data-table>
                <!-- entrys save table -->
                <v-data-table
                    :headers="titleEntrys"
                    :items="edit"
                    :items-per-page="20"
                    height="650px"
                    dense
                    fixed-header
                    :search="searchEdit"
                    v-if="action == 2"
                    class="elevation-1"
                >
                    <template v-slot:top>
                        <v-container grid-list-xs fluid>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Search"
                                        v-model="searchEdit"
                                        hide-details
                                        dense
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:item.shifts="{ item }">
                        <v-combobox
                            placeholder="Select shift"
                            class="mx-3"
                            dense
                            hide-details
                            :disabled="item.Find"
                            v-model="item.shifts"
                            :items="shifts"
                            required
                            :rules="[v => !!v || 'Required']"
                            :item-text="'text'"
                            :item-value="'ShiftDetail'"
                            auto-select-first
                            @change="addChange(item.shifts, item, 'shifts')"
                        >
                        </v-combobox>
                    </template>
                    <template v-slot:item.Date="{ item }">
                        <v-text-field
                            v-model="item.Date"
                            hide-details
                            :disabled="item.Find"
                            dense
                            :placeholder="$store.state.placeholder"
                            v-mask="'####-##-##'"
                            :rules="dateRules"
                            @change="addChange(item.Date, item, 'Date')"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.invoiceNo="{ item }">
                        <v-text-field
                            v-model="item.invoiceNo"
                            hide-details
                            :disabled="item.Find"
                            dense
                            :rules="[v => !!v || 'Required']"
                            @change="
                                addChange(item.invoiceNo, item, 'invoiceNo')
                            "
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.Qty="{ item }">
                        <v-text-field
                            v-model="item.Qty"
                            hide-details
                            :disabled="item.Find"
                            dense
                            @change="addChange(item.Qty, item, 'Qty')"
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.GST="{ item }">
                        <v-text-field
                            v-model="item.GST"
                            @change="addChange(item.GST, item, 'GST')"
                            hide-details
                            :disabled="item.Find"
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.total="{ item }">
                        <v-text-field
                            v-model="item.total"
                            hide-details
                            :disabled="item.Find"
                            @change="addChange(item.total, item, 'total')"
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.actualPrice="{ item }">
                        <v-text-field
                            v-model="item.actualPrice"
                            @change="
                                addChange(item.actualPrice, item, 'actualPrice')
                            "
                            hide-details
                            :disabled="item.Find"
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.actualCost="{ item }">
                        <v-text-field
                            v-model="item.actualCost"
                            @change="
                                addChange(item.actualCost, item, 'actualCost')
                            "
                            hide-details
                            :disabled="item.Find"
                            dense
                            :rules="[
                                v => !!v || 'Required',
                                v =>
                                    (!isNaN(parseFloat(v)) && v >= 0) ||
                                    'Only numbers'
                            ]"
                        >
                        </v-text-field>
                    </template>
                    <template v-slot:item.expenseType="{ item }">
                        <v-combobox
                            class="mx-3"
                            v-model="item.expenseType"
                            @change="
                                addChange(item.expenseType, item, 'expenseType')
                            "
                            :items="fuelType"
                            dense
                            hide-details
                            :disabled="item.Find"
                            :item-text="'Type'"
                            :item-value="'OOExpTypeId'"
                            :rules="[v => !!v || 'Required']"
                            auto-select-first
                        ></v-combobox>
                    </template>
                    <template v-slot:item.Province="{ item }">
                        <v-combobox
                            placeholder="Select province"
                            class="mx-3"
                            v-model="item.Province"
                            :items="provinces"
                            @change="addChange(item.Province, item, 'Province')"
                            required
                            hide-details
                            :disabled="item.Find"
                            dense
                            :rules="[v => !!v || 'Required']"
                            :item-text="'Province'"
                            :item-value="'ProvinceAbbr'"
                            auto-select-first
                        >
                        </v-combobox>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-btn color="red" icon @click="confirmDelete(item)"
                            ><v-icon>mdi-delete-sweep-outline</v-icon></v-btn
                        >
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <check
            v-if="$store.state.fuel.check"
            :statement="searchStatement"
        ></check>
        <entries v-if="$store.state.payroll.entries"></entries>
    </v-container>
</template>
<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import { mask } from 'vue-the-mask';
import check from './../Modals/Administration/Fuel/CheckTotalsExcel.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import entries from './FuelExpenseEntries.vue';
export default {
    name: 'FuelExpensesEntries',
    components: {
        check,
        entries,
        ConfirmDialogue
    },
    directives: {
        mask
    },
    data: function() {
        return {
            driver: null,
            drivers: [],
            excel: null,
            jsonData: null,
            entries: [],
            supplier: [],
            suppliers: [],
            shifts: [],
            date: '',
            fuelType: [],
            stDate: '',
            valid: false,
            search: '',
            province: '',
            dialog: false,
            dialogDelete: false,
            edit: [],
            chagn: false,
            parms: [],
            editedIndex: -1,
            editedItem: {
                shifts: {
                    ShiftDetail: '',
                    driver: '',
                    shift_header: '',
                    truck: ''
                },
                invoiceNo: '',
                expenseType: '',
                qty: '',
                gst: '',
                total: '',
                actualPrice: '',
                actualCost: ''
            },
            value: 0,
            defaultItem: {
                shifts: {
                    ShiftDetail: '',
                    driver: '',
                    shift_header: '',
                    truck: ''
                },
                invoiceNo: '',
                expenseType: '',
                qty: '',
                actualPrice: '',
                actualCost: ''
            },
            changes: [],
            stNumber: '',
            provinces: [],
            comboShifts: '',
            invoiceNo: '',
            expenseType: '',
            qty: '',
            gst: '',
            total: '',
            actualPrice: '',
            actualCost: '',
            OOExpId: '',
            action: 0,
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            titles: [
                { text: 'Shift', value: 'shifts', width: '15%' },
                { text: 'Driver', value: 'driver', width: '9%' },
                { text: 'Date', value: 'Date', width: '5%' },
                { text: 'Time', value: 'Time', width: '4%' },
                { text: 'Invoice No.', value: 'invoiceNo', width: '8%' },

                { text: 'Expense Type', value: 'expenseType', width: '9%' },

                { text: 'QTY', value: 'Qty', width: '3%' },
                { text: 'GST', value: 'GST', width: '5%' },
                { text: 'Total', value: 'total', width: '5%' },
                { text: 'Province', value: 'Province', width: '9%' },
                { text: 'City', value: 'City', width: '5%' },
                { text: 'Site', value: 'Site', width: '5%' },
                { text: 'Location', value: 'Location', width: '5%' },

                { text: 'Actual Price', value: 'actualPrice', width: '5%' },
                { text: 'Actual Cost', value: 'actualCost', width: '5%' },
                { text: 'Actions', value: 'status', width: '2%' }
            ],
            titleEntrys: [
                { text: 'Shift', value: 'shifts', width: '25%' },
                { text: 'Date', value: 'Date', width: '11%' },
                { text: 'Invoice No.', value: 'invoiceNo', width: '8%' },

                { text: 'Expense Type', value: 'expenseType', width: '11%' },

                { text: 'QTY', value: 'Qty', width: '8%' },
                { text: 'GST', value: 'GST', width: '5%' },
                { text: 'Total', value: 'total', width: '5%' },
                { text: 'Province', value: 'Province', width: '9%' },

                { text: 'Actual Price', value: 'actualPrice', width: '9%' },
                { text: 'Actual Cost', value: 'actualCost', width: '9%' },
                { text: 'Actions', value: 'status', width: '2%' }
            ],
            excel: [],
            headers: [
                { text: 'Card#', value: 'Card' },
                { text: 'Date', value: 'Date' },
                { text: 'Time', value: 'Time' },
                {
                    text: 'Transaction Processiong Date',
                    value: 'TransactionProcessiongDate'
                },
                { text: 'Billing Date', value: 'BillingDate' },
                { text: 'Document', value: 'Document' },
                { text: 'REFERENCE', value: 'Reference' },
                { text: 'CHANNEL', value: 'Channel' },
                { text: 'SITE', value: 'Site' },
                { text: 'LOCATION', value: 'Location' },
                { text: 'CITY', value: 'City' },
                { text: 'PROV', value: 'Prov' },
                { text: 'PRODUCT', value: 'Product' },
                { text: 'Volume ', value: 'Volume' },
                { text: 'PRICE PER LITRE', value: 'PricePerLitre' },
                // { text: 'PRICE PER LITRE1', value: 'PricePerLitre1' },
                { text: 'FET ', value: 'Fet' },
                { text: 'PFT ', value: 'Pft' },
                { text: 'FCTPCT ', value: 'FctPct' },
                { text: 'Urban Tax ', value: 'UrbanTax' },
                { text: 'GST', value: 'Gst' },
                { text: 'PST', value: 'Pst' },
                { text: 'Amount', value: 'Amount' },
                { text: 'Discount', value: 'Discount' },
                { text: 'Net', value: 'Net' },
                { text: 'Misc', value: 'Misc' },
                { text: 'Driver Name1', value: 'DriverName' }
            ],
            headerMapping: {
                Card: 'Card',
                DATE: 'Date',
                TIME: 'Time',
                TransactionProcessiongDate: 'TransactionProcessiongDate',
                BillingDate: 'BillingDate',
                Document: 'Document',
                REFERENCE: 'Reference',
                Channel: 'Channel',
                SITE: 'Site',
                LOCATION: 'Location',
                CITY: 'City',
                PROV: 'Prov',
                PRODUCT: 'Product',
                Volume: 'Volume',
                PRICEPERLITRE: 'PricePerLitre',
                FET: 'Fet',
                PFT: 'Pft',
                FCTPCT: 'FctPct',
                UrbanTax: 'UrbanTax',
                GST: 'Gst',
                PST: 'Pst',
                Amount: 'Amount',
                Discount: 'Discount',
                Net: 'Net',
                Misc: 'Misc',
                DriverName1: 'DriverName'
            },
            searchStatement: null,
            expensesEntries: [
                {
                    shifts: {
                        ShiftDetail: '',
                        driver: '',
                        shift_header: '',
                        truck: ''
                    },
                    text: '',
                    invoiceNo: '',
                    expenseType: '',
                    qty: '',
                    gst: '',
                    total: '',
                    actualPrice: '',
                    actualCost: '',
                    actions: ''
                }
            ],
            data: [],
            dataLoading: true,
            searchRows: '',
            searchEdit: ''
        };
    },
    computed: {
        filteredItems() {
            return this.entries.filter(i => {
                return !this.driver || i.driver == this.driver.Driver;
            });
        },
        filterSearchItems() {
            return this.filteredItems.filter(i => {
                return (
                    i.Location.toLowerCase().indexOf(
                        this.searchRows.toLowerCase()
                    ) !== -1
                );
            });
        },
        filterEditItems() {
            return this.edit.filter(i => {
                return (
                    i.text.toLowerCase().indexOf(this.search.toLowerCase()) !==
                    -1
                );
            });
        }
    },
    mounted() {
        this.loadSuppliers();
        this.loadProvinces();
        this.loadFuelType();
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        }
    },
    methods: {
        readExcel: async function(e) {
            console.log(e.target.files[0]);
            this.name = e.target.files[0].name;
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = e => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                this.jsonData = JSON.stringify(jsonData, null, 2);
            };

            reader.readAsArrayBuffer(file);
        },
        sendExcel: function() {
            var str = this.$store;
            var parms = {
                data: this.jsonData
            };
            str.state.isLoading = true;
            axios
                .post('fuel-expense/expenses/preparing-data', parms)
                .then(async response => {
                    this.excel = await response.data.map(this.mapping);
                    this.searchStatement = this.stNumber;
                    this.action = 0;
                    // Convertir el nuevo objeto a JSON
                    console.log(this.excel);
                    // this.loadShifts(1);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        mapping: function(item) {
            let newItem = {};
            for (let key in item) {
                if (this.headerMapping[key]) {
                    newItem[this.headerMapping[key]] = item[key];
                } else {
                    newItem[key] = item[key]; // Mantener las claves no mapeadas
                }
            }
            return newItem;
        },
        uploadFile: async function() {
            var str = this.$store;
            if (
                this.supplier == null ||
                this.stNumber == '' ||
                this.stDate == ''
            ) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Complete the required fields'
                });
                this.action = 0;
            } else {
                await this.excel.forEach(x => {
                    x.Statement = this.stNumber;
                    x.Supplier = this.supplier.OOSupplierId;
                    x.StatementDate = this.stDate;
                });
                var parms = {
                    data: this.excel
                };

                str.state.isLoading = true;
                axios
                    .post('fuel-expense/expenses/save/petro-excel', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        // this.excel = await response.data.map(this.mapping);
                        // Convertir el nuevo objeto a JSON
                        // console.log(this.excel);
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'File saved successfully'
                        });
                        this.loadShifts(1);
                        str.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        str.state.isLoading = false;
                    });
            }
        },
        chargeExcel: function() {
            var str = this.$store;
            if (this.searchStatement == null) {
                str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Enter a StatementNum'
                        });
            }else{
                
            // str.state.isLoading = true;
            var parms = {
                StNumber: this.searchStatement
            };
            this.entries = null;
            axios
                .post('fuel-expense/search/excel', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => { 
                    str.state.isLoading = false;
                    console.log(response.data);
                    
                        this.stDate = response.data.info.StatementDate;
                        this.stNumber = response.data.info.Statement;
                        var idx = await this.suppliers.findIndex(itm => {
                            return itm.OOSupplierId == response.data.info.Supplier;
                        });
                        console.log(idx);
                        this.supplier = this.suppliers[idx];
                    
                    if(response.data['records'] == []){
                        this.entries = [];
                    }else{
                        this.entries = response.data['records'].map(itm => {
                            return {
                                Date: itm['Date'],
                                expenseType: itm['ProductCode'],
                                invoiceNo: itm['InvoiceNumber'],
                                Qty: itm['Qty'],
                                GST: Number(itm.Qty * 0.0702).toFixed(2),
                                total: itm['ProductCode'] == 'EF' ? itm['ActualCost'] : Number(itm.Qty * 0.61).toFixed(2),
                                Abbr: itm['Province'],
                                Province: itm['Province'],
                                actualPrice: itm['ActualPrice'],
                                actualCost: itm['ActualCost'],
                                status: itm['Status'],
                                driver: itm['Driver'],
                                City: itm['City'],
                                Site: itm['Site'],
                                Location: itm['Location'],
                                shifts: [],
                                Save: false,
                                Time: itm['Time'],
                                id: itm['id']
                            };
                        });
                        this.entries.forEach(elm => {
                            if (elm.expenseType == 'D1') {
                                elm.expenseType = 1;
                            } else {
                                elm.expenseType = 13;
                            }
                            if (elm.status == 1) {
                                elm.Save = true;
                            }
                            switch (elm.Province) {
                                case 'PQ':
                                    elm.Province = 'QB';
                                    break;
                                case 'AB':
                                    elm.Province = 'AL';
                                    break;
                                default:
                                    console.log(elm.Province);
                                    break;
                            }
                            const type = this.fuelType.findIndex(tye => {
                                return tye.OOExpTypeId == elm.expenseType;
                            });
                            const prov = this.provinces.findIndex(pro => {
                                return pro.ProvinceAbbr == elm.Province;
                            });
                            elm.Province = this.provinces[prov];
                            elm.expenseType = this.fuelType[type];
                        });
                        console.log(this.entries);
                        this.drivers = response.data['records'].map(itm => {
                            return {
                                Driver: itm['Driver']
                            };
                        });
                        let hash = {};
                        this.drivers = await this.drivers.filter(o =>
                            hash[o.Driver] ? false : (hash[o.Driver] = true)
                        );
                        console.log(this.drivers);
                        this.value = 2;
                        this.action = 1;
                        this.value = 0;
                        this.$store.state.fuel.check = true;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
                
            }
        },
        calculate: function(itm) {
            itm.GST = Number(itm.Qty * 0.0702).toFixed(2);
            itm.total = Number(itm.Qty * 0.61).toFixed(2);
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('fuel-supplier')
                .then(response => {
                    console.log(response.data);
                    this.suppliers = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadProvinces: function() {
            this.$store.state.isLoading = true;
            axios
                .get('province')
                .then(response => {
                    console.log(response.data);
                    this.provinces = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadShifts: function(tgg) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get(
                    'shift-detail/dates-fuel/excel/' +
                        this.searchStatement +
                        '/' +
                        this.$store.state.expensesEntries.start_date +
                        '/' +
                        this.$store.state.expensesEntries.end_date,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    str.state.isLoading = false;
                    console.log(response.data);
                    this.shifts = response.data.map(x => {
                        return {
                            text:
                                x.truck == null
                                    ? x.shift_header.Date +
                                      ' ' +
                                      x.shift_header.Shift +
                                      ' - ' +
                                      x.driver.Name +
                                      ' - ' +
                                      x.Trailer
                                    : x.shift_header.Date +
                                      ' ' +
                                      x.shift_header.Shift +
                                      ' - ' +
                                      x.driver.Name +
                                      ' - ' +
                                      x.truck.Truck +
                                      ' - ' +
                                      x.Trailer,
                            Driver: x.Driver,
                            ShiftDetail: x.ShiftDetail,
                            Truck: x.Truck,
                            ShiftHeaderNum: x.ShiftHeaderNum
                        };
                    });
                    if (tgg) {
                        this.chargeExcel();
                    }
                    // this.shifts.forEach(element => {
                    //     if(element.driver.Name == undefined || element.driver.Name == null){
                    //         console.log(element);
                    //     }
                    //     element.text =
                    //         element.shift_header.Date +
                    //         ' ' +
                    //         element.shift_header.Shift +
                    //         ' - ' +
                    //         element.driver.Name +
                    //         ' - ' +
                    //         element.truck.Truck;
                    // });
                    this.expensesEntries.shifts = response.data;
                    console.log(this.expensesEntries);
                })
                .catch(error => {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        loadFuelType: function() {
            this.$store.state.isLoading = true;
            axios
                .get('fuel-expense-type')
                .then(response => {
                    this.$store.state.isLoading = false;
                    console.log(response.data);
                    this.fuelType = response.data;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        resetVariables: function() {
            this.comboShifts = [];
            this.province = [];
            this.expenseType = [];
            this.gst = null;
            this.total = null;
            this.qty = null;
            this.actualCost = null;
            this.actualPrice = null;
            this.invoiceNo = null;
        },
        saveMtxFuel: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            var check = await this.entries.filter(ent => {
                return ent.status == true;
            });
            check = await check.filter(ent => {
                return ent.Save == false;
            });
            var load = true;
            await check.forEach(elm => {
                if (elm.shifts.length == 0) {
                    load = false;
                }
            });
            if (load == false) {
                this.$store.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Missing fields to be completed'
                });
            } else {
                var parms = {
                    data: check,
                    Supplier: this.supplier.OOSupplierId,
                    StNumber: this.stNumber,
                    StDate: this.stDate
                };

                axios
                    .post('fuel-expense/mtx/fuel', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'New entries are saved correctly'
                        });
                        //  this.sendExcel();
                        this.chagn = true;
                        this.chargeExcel();
                    })
                    .catch(error => {
                        this.$store.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                        console.log(error);
                    });
            }
        },
        addChange: function(value, itm, type) {
            const idx = this.parms.findIndex(pro => {
                return pro.OOExpId == itm.OOExpId;
            });
            console.log(idx, itm.OOExpId, value);
            switch (type) {
                case 'shifts':
                    if (value == null) {
                        this.parms[idx].ShiftDetail = null;
                        this.parms[idx].TruckId = null;
                    } else {
                        this.parms[idx].ShiftDetail = value.ShiftDetail;
                        this.parms[idx].TruckId = value.Truck;
                    }
                    break;
                case 'invoiceNo':
                    this.parms[idx].InvoiceNo = value;
                    break;
                case 'Date':
                    this.parms[idx].Date = value;
                    break;
                case 'Qty':
                    itm.GST = Number(value * 0.0702).toFixed(2);
                    itm.total = Number(value * 0.61).toFixed(2);
                    this.parms[idx].GST = parseFloat(
                        Number(value * 0.0702).toFixed(2)
                    );
                    this.parms[idx].Total = parseFloat(
                        Number(value * 0.61).toFixed(2)
                    );
                    this.parms[idx].Qty = parseFloat(value);
                    break;
                case 'GST':
                    this.parms[idx].GST = parseFloat(value);
                    break;
                case 'total':
                    this.parms[idx].Total = parseFloat(value);
                    break;
                case 'actualPrice':
                    this.parms[idx].ActualPrice = parseFloat(value);
                    break;
                case 'actualCost':
                    this.parms[idx].ActualCost = parseFloat(value);
                    break;
                case 'expenseType':
                    this.parms[idx].Type = value.OOExpTypeId;
                    break;
                case 'Province':
                    this.parms[idx].Province = value.ProvinceAbbr;
                    break;
            }
            console.log(this.parms);
        },
        getEntriesbyStNumber: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('fuel-expense/details/' + this.stNumber, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    this.edit = await response.data.map(itm => {
                        return {
                            Date: itm['Date'],
                            expenseType: itm.expense_type,
                            invoiceNo: itm['InvoiceNo'],
                            Qty: itm['Qty'],
                            GST: Number(itm.Qty * 0.0702).toFixed(2),
                            total: Number(itm.Qty * 0.61).toFixed(2),
                            Abbr: itm['Province'],
                            Province: itm['Province'],
                            actualPrice: itm.ActualPrice,
                            actualCost: itm.ActualCost,
                            ShiftDetail:
                                itm.shift_detail == null
                                    ? null
                                    : itm.shift_detail.ShiftDetail,
                            shifts: [],
                            OOExpId: itm.OOExpId,
                            SuppInvNo: itm.SuppInvNo,
                            text: itm.shift_detail.shift_header.Date +
                                        ' ' +
                                        itm.shift_detail.shift_header.Shift +
                                        ' - ' +
                                        itm.shift_detail.driver.Name +
                                        ' - ' +
                                        itm.shift_detail.truck.Truck,
                            ID: itm['ID']
                        };
                    });
                    console.log('this.edit',this.edit)
                    this.parms = await response.data.map(itm => {
                        return {
                            // Date: null,
                            // Type: null,
                            // InvoiceNo: null,
                            // Qty: itm.Qty,
                            // GST: null,
                            // Total: null,
                            // TruckId:null,
                            // Province: null,
                            // ActualPrice: null,
                            // ActualCost: null,
                            // ShiftDetail: null,
                            OOExpId: itm.OOExpId
                            // Find:null,
                        };
                    });
                    await this.edit.forEach(elm => {
                        const prov = this.provinces.findIndex(pro => {
                            return pro.ProvinceAbbr == elm.Province;
                        });
                        const shift = this.shifts.findIndex(shift => {
                            return shift.ShiftDetail == elm.ShiftDetail;
                        });
                        if (elm.ShiftDetail == null) {

                        } else {
                            if(shift < 0){
                                elm.shifts = elm.text;  
                            }else{
                                console.log(shift);
                                elm.shifts = this.shifts[shift];
                                elm.Find = false;
                                elm.text = this.shifts[shift].text;
                                elm.Province = this.provinces[prov];
                            }
                        }
                    });

                    console.log(this.edit, 'Here');
                    this.action = 2;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        save: function() {
            if (this.action == 1) {
                this.saveMtxFuel();
            } else if (this.action == 2) {
                this.updateMtxFuel();
            }
        },
        clean: function() {
            var parms = this.parms.map(item => {
                Object.keys(item).forEach(key => {
                    if (key == 'ShiftDetail' || key == 'TruckId') {
                    } else {
                        if (item[key] === null) delete item[key];
                    }
                });
                return item;
            });
            this.parms = parms;
        },
        updateMtxFuel: async function() {
            var str = this.$store;
            await this.clean();
            var parms = {
                data: this.parms
            };
            axios
                .post('fuel-expense/mtx/fuel/update', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Changes have been successfully saved'
                    });
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },
        async confirmDelete(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this record ' + itm.text,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch

            if (ok) {
                this.deleteOORecord(itm);
            }
        },
        deleteOORecord: function(itm) {
            console.log(itm);
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .delete('fuel-expense/' + itm.OOExpId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    const idx = this.edit.findIndex(x => {
                        return x.OOExpId == itm.OOExpId;
                    });
                    this.edit.splice(idx, 1);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Record successfully deleted'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },

        downLoadExcelRecored: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StNumber: this.searchStatement
            };
            axios
                .post('fuel-expense/download/excel/recored', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Excel - ' + this.searchStatement + '.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                    this.action = 2;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
